import { i18n } from '@/locales';
import { storeDeliveryStatusType } from '@/constants/storeManagement/storeStatusOptionList';
const lc = 'views.store_management.';
const storeListTableHeader = [
    {
        title: i18n.t(`${lc}status`),
        align: 'center',
        sortable: true,
        value: 'useYn',
        width: 74,
    },
    // 자사/공유 (P1에서는 소속만 진행)
    // {
    //   title: '구분',
    //   align: 'start',
    // sortable: true,
    //   value: 'section',
    //   width: 92,
    // },
    {
        title: i18n.t(`${lc}hub_name`),
        align: 'center',
        sortable: true,
        value: 'hubId',
        width: 194,
    },
    {
        title: i18n.t(`${lc}name`),
        align: 'center',
        sortable: true,
        value: 'name',
        width: 196,
    },
    {
        title: i18n.t(`${lc}rest_days`),
        align: 'center',
        sortable: false,
        value: 'restDays',
        width: 168,
    },
    {
        title: i18n.t(`${lc}working_time`),
        align: 'center',
        sortable: true,
        value: 'workingTime',
        width: 136,
    },
    {
        title: i18n.t(`${lc}phone`),
        align: 'center',
        sortable: true,
        value: 'phone',
        width: 148,
    },
    {
        title: i18n.t(`${lc}ceo_name`),
        align: 'center',
        sortable: true,
        value: 'ceoName',
        width: 100,
    },
    {
        title: i18n.t(`${lc}address`),
        align: 'center',
        sortable: false,
        value: 'addressRoad',
        width: 340,
    },
    {
        title: i18n.t(`${lc}code`),
        align: 'center',
        sortable: true,
        value: 'code',
        width: 100,
    },
    {
        title: i18n.t(`${lc}vat_rate`),
        align: 'center',
        sortable: true,
        value: 'vatRate',
        width: 120,
    },
    // 관리비 유형
    {
        title: i18n.t(`${lc}delivery_pay_flag`),
        align: 'center',
        sortable: true,
        value: 'deliveryPayFlag',
        width: 110,
    },
    // 관리비 상세
    {
        title: i18n.t(`${lc}delivery_detail`),
        align: 'center',
        sortable: true,
        value: 'deliveryFeeMonthlyDay',
        width: 300,
    },
    {
        title: i18n.t(`${lc}deposit_baromoney`),
        align: 'center',
        sortable: true,
        value: 'depositBaromoney',
        width: 144,
    },
    {
        title: i18n.t(`${lc}baromoney`),
        align: 'center',
        sortable: true,
        value: 'baromoney',
        width: 144,
    },
    // 생성일
    {
        title: i18n.t(`${lc}created_at`),
        align: 'center',
        sortable: true,
        value: 'createdAt',
        width: 118,
    },
];
/**
 * 상점 상태
 * @param storeDetail
 * @returns
 */
export const getStoreStatusContent = (storeDetail) => {
    const lcDetail = 'views.store_management_detail.';
    if (!storeDetail) {
        return null;
    }
    return [
        {
            text: i18n.t(`${lcDetail}delivery_status`),
            value: i18n.t(storeDeliveryStatusType[storeDetail.deliveryWorkYn].text),
            textColor: 'green darken-4',
            color: 'green darken-4',
        },
        {
            text: i18n.t(`${lcDetail}baromoney_balance`),
            value: storeDetail.formattedBaromoney,
            textColor: 'blue darken-4',
            color: 'blue darken-4',
        },
    ];
};
export default storeListTableHeader;
